export const attributesToIgnore = [
  'iss', 'sub', 'aud', 'iat', 'exp', 'uid', 'idp_fqdn', 'e-mail', 'nonce', 'idp_id'
];